const asLowerCase = (a) => a.toLowerCase();
const isActive = (d) => asLowerCase(d?.status) === 'active';
const asArray = (v) => Array.from(v);

// eslint-disable-next-line import/prefer-default-export
const filterActive = (d) => d.reduce((a, c) => (isActive(c) ? [...a, c] : a), []);
const firstUpperCase = (s) =>
  s.toLowerCase().replace(/\b[a-z](?=[a-z]{2})/g, (letter) => letter.toUpperCase());
const capitaliseFirstLetter = (arr) => arr.map((v) => firstUpperCase(v));

const isContainerViewPort = (c) => c.classList.contains('map-viewport-container');
const sliceTags = (t) => t.slice(0, 2).join(', ');
const addContent = (t) => `... +${t.length - 2} more`;
const maybeAddContent = (t) =>
  t.length === 2 ? [sliceTags(t)] : [`${sliceTags(t)} ${addContent(t)}`];
const maybeSliceTags = (t, c) => (t.length >= 2 && isContainerViewPort(c) ? maybeAddContent(t) : t);
const addPill = (el) => el.classList.add('tag-pill');
const maybeAddPill = (el, c) => (!isContainerViewPort(c) ? addPill(el) : el);
const setContent = (el, c) => (el.textContent = c);
const appendTags = (mapItemProp, tag, container) => {
  const tagElement = document.createElement('div');
  setContent(tagElement, tag);
  maybeAddPill(tagElement, container);
  return mapItemProp.appendChild(tagElement);
};
const setTags = (container) => (v) => {
  const tags = v.textContent.split(',').map((tag) => tag.trim());
  setContent(v);
  maybeSliceTags(tags, container).map((tag) => appendTags(v, tag, container));
};
const selectTags = (v) => v.querySelectorAll('map-item-prop[name="tags"]');
const isAddedNodeMapItem = (node) =>
  // eslint-disable-next-line no-undef
  node instanceof Element && node.nodeName.toLowerCase() === 'map-item';
const visualiseTags = (container) => {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      const addedNodes = Array.from(mutation.addedNodes);
      const mapItemProps = addedNodes
        .filter(isAddedNodeMapItem)
        .flatMap((mapItem) => asArray(selectTags(mapItem)));

      mapItemProps.forEach(setTags(container));
    });
  });
  return observer.observe(container, { childList: true, subtree: true });
};

module.exports = {
  filterActive,
  capitaliseFirstLetter,
  visualiseTags,
};
